import type { BatchAddScenesResult } from '@/apis/simulation';

/**
 * 批量入集结果 → 提示文案 + 提示级别。
 * 有不合格被跳过的场景时降级为 warning，并按原因聚合计数，例如：
 * 「加入 3 个，1 个已在集合内，2 个不合格已跳过（场景状态不合格: 已录入 ×2）」
 */
export const formatBatchAddResult = (
  res: BatchAddScenesResult,
): { type: 'success' | 'warning'; text: string } => {
  const rejected = res.rejected ?? [];
  const parts: string[] = [];
  if (res.added) parts.push(`加入 ${res.added} 个`);
  if (res.skipped) parts.push(`${res.skipped} 个已在集合内`);
  if (rejected.length) {
    const byReason = new Map<string, number>();
    rejected.forEach(({ reason }) => byReason.set(reason, (byReason.get(reason) ?? 0) + 1));
    const detail = [...byReason].map(([reason, n]) => `${reason} ×${n}`).join('；');
    parts.push(`${rejected.length} 个不合格已跳过（${detail}）`);
  }
  return {
    type: rejected.length ? 'warning' : 'success',
    text: parts.length ? parts.join('，') : '已完成',
  };
};
